import { observable, computedFrom, BindingEngine, bindable, bindingMode, autoinject } from 'aurelia-framework';
import { RequestDto } from '../../../data/typegen/dtos/request-dto';
@autoinject()
export class WorkflowStageProgress {

    @bindable({ defaultBindingMode: bindingMode.oneWay }) request: RequestDto;

    constructor() {
    }

    attached() {
    }
}